const resources = {
    title: 'AI Beauty Chat',
    placeholder: 'Message...',
    shareFeedback: 'Share Feedback',
    new: 'NEW',
    addToBasket: 'Add to Basket',
    size: 'Size',
    errorMessage: 'Something went wrong. Please try restarting the chat or',
    resendYourMessage: 'resend your message',
    addToBasketErrorTitle: 'Something went wrong',
    addToBasketErrorMessage: 'We couldn\'t add this item to your basket. Please try again.',
    ok: 'OK',
    lookingForAGift: 'I am looking for a gift!',
    startChat: 'Start a Chat',
    tryAsking: 'Try Asking',
    topHairCareQuestions: 'Top Hair Care Questions',
    topSkincareQuestions: 'Top Skincare Questions',
    topMakeupQuestions: 'Top Makeup Questions',
    topFragranceQuestions: 'Top Fragrance Questions',
    topBathBodyQuestions: 'Top Bath & Body Questions',
    description: 'Powered by millions of reviews, exclusive product info, and your personal beauty preferences.',
    welcomeBack: 'Welcome back!',
    feedback: 'Feedback',
    added: 'Added',
    free: 'FREE',
    points: 'Points',
    purchasedOn: 'PURCHASED ON',
    color: 'Color:',
    shade: 'Shade:',
    variant: 'Variant:',
    viewAll: 'View all',
    carouselLabel: 'Promotions carousel',
    carouselPrevious: 'Previous promotions',
    carouselNext: 'Next promotions',
    fromCustomerReviews: 'From customer reviews:',
    customerReviewSentiments: 'Customer review sentiments',
    positiveSentiment: 'Positive',
    negativeSentiment: 'Negative',
    positiveReviewsMentioning: 'Positive reviews mentioning',
    negativeReviewsMentioning: 'Negative reviews mentioning',
    sentimentQueryFor: 'for',
    newChat: 'New Chat',
    whyRecommended: 'Why this product was recommended',
    in: 'in',
    loadingChatPrompts: 'Loading chat prompts',
    productsUnavailable: 'We couldn\'t load product recommendations.',
    promotionsUnavailable: 'We couldn\'t load promotions.',
    responseUnavailable: 'We couldn\'t load part of this response.',
    nextPage: 'Next page',
    previousPage: 'Previous page',
    shadeMatch: 'Shade match'
};

export default function getResource(label) {
    return resources[label];
}
